export default "__VITE_ASSET__BZwcReXZ__"